module.exports = __webpack_public_path__ + "img/background_blue.d95ba456.png";